import { useEffect } from "react";
import { useMap } from "react-leaflet";

export const CAMERA_PICKING_CLASS = "viewport3d-camera-picking";

/**
 * While a camera is being picked (take main camera or a Set Camera interaction), every
 * other marker is dimmed, shrunk and made inert so the cameras read as the only choice.
 * They stay visible on purpose: a camera is chosen by what it frames. See
 * InteractionPointPreview.css for the styles keyed on this class.
 */
export default function Viewport3DCameraPickingFocus(props: { active: boolean }) {
  const map = useMap();
  const { active } = props;

  useEffect(() => {
    if (!active) return;
    const container = map.getContainer();
    container.classList.add(CAMERA_PICKING_CLASS);
    return () => container.classList.remove(CAMERA_PICKING_CLASS);
  }, [active, map]);

  return null;
}
